export default __webpack_public_path__ + "static/media/off-icon.24855991.png";